import { render, staticRenderFns } from "./CatchCOVID.vue?vue&type=template&id=1af49af8&"
import script from "./CatchCOVID.vue?vue&type=script&lang=js&"
export * from "./CatchCOVID.vue?vue&type=script&lang=js&"
import style0 from "./CatchCOVID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports